import {ApiResponseDto, BasePopupProps} from "@utils/Models";
import FlintTextArea from "@components/controls/FlintTextArea";
import * as icons from "@fortawesome/free-solid-svg-icons"
import FlintButton from "@components/controls/FlintButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useFlintNotificationContext} from "@components/page_components/common/notifications/FlintNotificationContext";
import {ImportComponentsResponse} from "@pages/administration/components/component.models";
import {ApiUrl_Components_ImportComponents} from "@utils/Endpoints";
import axios from "axios";
import FlintLoadingWrapper from "@components/page_components/common/loading/FlintLoadingWrapper";

export default function ImportComponentsPanel(props: ImportComponentsPanelProps) {
    const {state, handlers} = useImportComponentsPanel(props);
    const {t} = useTranslation();

    return (
        <FlintLoadingWrapper showLoading={state.isLoading.get}>
            <div className="alert alert-info font-size-md">
                Please paste multiple components. Each component should be placed in a separate line. CODE should be the
                first column and must not contain any spaces. Codes may include special characters such as&nbsp;
                <span className="fw-bold">-</span> and <span className="fw-bold">/</span>, and must be at most 9 characters long.
                The first space in each row is the separator between the component CODE and DESCRIPTION. All text after
                the first space is treated as the component's description.
                Example:
                <div className="w-50 text-left mt-3">
                    <span className="fw-bold text-danger">ABC-12345</span>&nbsp;Process Yellow<br/>
                    <span className="fw-bold text-danger">YEA30080</span>&nbsp;Process Magenta
                </div>
            </div>
            <div className={"form-group"}>
                <FlintTextArea required={true} autoSize={false} rows={10} value={state.componentData.get}
                               onChange={x => state.componentData.set(x.value)}/>
            </div>
            <div className={"button-row"}>
                <FlintButton themeColor={"secondary"} onClick={props.OnCancelled}>{t("Cancel")}</FlintButton>
                <FlintButton onClick={handlers.handleImportComponentsClicked}>
                    <FontAwesomeIcon className={"me-2"} icon={icons.faUpload}/>
                    {t("LAB_ImportComponents")}
                </FlintButton>
            </div>
        </FlintLoadingWrapper>
    )
}

export interface ImportComponentsPanelProps extends BasePopupProps<ImportComponentsResponse> {

}

function useImportComponentsPanel(props: ImportComponentsPanelProps) {
    const [componentData, setComponentData] = useState<string>("");
    const {showNotification} = useFlintNotificationContext();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    function handleImportComponentsClicked() {
        if (!componentData) {
            showNotification("There is nothing to import at the moment!", {style: "error"})
            return;
        }
        setIsLoading(true);
        return axios.post<ApiResponseDto<ImportComponentsResponse>>(ApiUrl_Components_ImportComponents, componentData)
            .then((response) => {
                setComponentData("");
                const result = response.data.Result;
                const message : string = `Successfully imported ${result.ItemsAdded} items. Items omitted: ${result.ItemsOmitted}`;
                showNotification(message, {style:"success"})
                props.OnConfirmedAndSaved(result);
            })
            .catch(error => {
                showNotification(error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return {
        state: {
            isLoading: {get: isLoading},
            componentData: {get: componentData, set: setComponentData}
        },
        handlers: {
            handleImportComponentsClicked,
        }
    }
}